import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { actions as alertActions } from '../store/dux/alerts-dux';

export function useAlerts() {
  const dispatch = useDispatch();

  const showError = useCallback(
    (error) => dispatch(alertActions.showError(error)),
    [dispatch],
  );

  const showInfo = useCallback(
    (info) => dispatch(alertActions.showInfo(info)),
    [dispatch],
  );

  return {
    showError,
    showInfo,
  };
}
